import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
export const fetcher = (url) => http.get(url).then((r) => r.data);
export const swrOpts = { revalidateOnFocus: false, keepPreviousData: true, dedupingInterval: 30000 };

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const variantFor = (p, opts = {}) =>
  (p.variants || []).find((v) => Object.entries(v.options).every(([k, val]) => opts[k] === val));

export const unitPrice = (p, opts = {}) => {
  if (p.variants?.length) return variantFor(p, opts)?.price ?? p.price;
  return p.price + (p.options || []).reduce((s, o) => s + (o.choices.find((c) => c.text === opts[o.name])?.modifier || 0), 0);
};

export const defaultOptions = (p) =>
  Object.fromEntries((p.options || []).map((o) => [o.name, (o.choices[o.default] || o.choices[0]).text]));

export const hasPriceRange = (p) =>
  p.variants?.length ? p.variants.some((v) => v.price > p.price) : (p.options || []).some((o) => o.choices.some((c) => c.modifier > 0));

export const stripHtml = (h = "") => h.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
